import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UsuarioAtualizacao, UsuarioCriacao, UsuarioResposta } from './usuario';
import { Pagina } from './pagina';

@Injectable({ providedIn: 'root' })
export class UsuarioAppService {
  private readonly apiUrl = `${environment.api}/usuarios`;

  constructor(private http: HttpClient) {}

  /** `GET /usuarios` → `PageUsuario`. */
  listar(
    page: number,
    size: number,
    filtro?: string,
    sort?: string | null,
  ): Observable<Pagina<UsuarioResposta>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (filtro?.trim()) params = params.set('filtro', filtro.trim());
    if (sort) params = params.set('sort', sort);
    return this.http.get<Pagina<UsuarioResposta>>(this.apiUrl, { params });
  }

  buscarPorId(id: string): Observable<UsuarioResposta> {
    return this.http.get<UsuarioResposta>(`${this.apiUrl}/${id}`);
  }

  criar(usuario: UsuarioCriacao): Observable<UsuarioResposta> {
    return this.http.post<UsuarioResposta>(this.apiUrl, usuario);
  }

  /** `PUT` é substituição: o corpo tem de descrever o usuário inteiro. Ver `UsuarioAtualizacao`. */
  atualizar(id: string, usuario: UsuarioAtualizacao): Observable<UsuarioResposta> {
    return this.http.put<UsuarioResposta>(`${this.apiUrl}/${id}`, usuario);
  }

}
